import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/**
 * Format a Date (defaults to now) as a LOCAL-timezone ISO date string
 * `YYYY-MM-DD`. Use everywhere the app previously called
 * `.toISOString().slice(0, 10)` for a "today" value — that function returns
 * the UTC date, which is a day behind for Australian users after 2pm-ish.
 */
export function todayLocalIso(d = new Date()) {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}
